'use strict';
(function($){


	var $rm_upload = $('button.rm-upload');
	$rm_upload.click(function(ev){
		ev.preventDefault();
		$(this).parent().addClass('d-none').next('.form-group').removeClass('d-none').next('input[type="hidden"]').val('');
		return false;
	});


	/******* DATE RANGE ********************/
	var $form = $('#daterange-form');
	var start = $form.find('input[name="start"]').val()
	var end = $form.find('input[name="end"]').val()

	var options = {
		autoUpdateInput: false,
		locale: {
			format: 'DD/MM/YYYY',
			cancelLabel: 'Clear'
		}
	}

	if(start && end){
		options.startDate = (start)? moment.unix(start).format("DD/MM/YYYY") : null;
		options.endDate = (end)? moment.unix(end).format("DD/MM/YYYY") : null;
	}

	var picker = $('input[name="daterange"]').daterangepicker(options);

	if(start && end) picker.val( moment.unix(start).format("DD/MM/YYYY") + ' - ' + moment.unix(end).format("DD/MM/YYYY") );

	$('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
		$(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
		var $form = $('#daterange-form');
		$form.find('input[name="start"]').val(picker.startDate.unix());
		$form.find('input[name="end"]').val(picker.endDate.unix());
		if(!$form.hasClass('daterange-no-submit')) $form.submit();
	});

	$('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
		$(this).val('');
		var $form = $('#daterange-form');
		$form.find('input[name="start"]').val(null)
		$form.find('input[name="end"]').val(null)
		if(!$form.hasClass('daterange-no-submit')) $form.submit();
	});

	$('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
		$(this).val('');
	});


	/******* DATA TABLE ********************/

	var $table = $('table').not('.no-dt');
	var $headColumns = $table.find('thead').find('th');
	var paging = ($table.find('tbody').find('tr').length > 10);
	var $filters = $table.prev('.filters');

	var selectTemplate = '';
	selectTemplate += '<div class="form-group col-12 col-sm-6 col-md">';
	selectTemplate += '<label>Category</label>';
	selectTemplate += '<select class="form-control">';
	selectTemplate += '<option value="null">All</option>';
	selectTemplate += '</select>';
	selectTemplate += '</div>';

	$table.dataTable({
		'paging': paging,
		'lengthMenu': [[25, 50, -1], [25, 50, 'All']],
		'columnDefs': [
			{ 'targets': 'date', "type": "date-eu" },
			{ 'targets': 'daterange', 'type': "dateRangeOrder" },
			{ 'targets': 'nosort', 'orderable': false }
		],
        initComplete: function () {
            this.api().columns().every( function () {
				var column = this;
				var $colHead = $($headColumns[column[0]]);

				if(!$colHead.hasClass('nosort') && !$colHead.hasClass('nofilter')){

					var $select = $(selectTemplate).appendTo($filters);
					$select.find('label').text($colHead.text());
					$select.find('select').on('change', function () {
						var val = $.fn.dataTable.util.escapeRegex( $(this).val() );
						if( val == 'null' ) val = '';
						if($colHead.text() == 'Status'){
							var $trs = $table.find('tbody').find('tr');
							$trs.each(function(){
								var text = $(this).find('td').eq($colHead.index()).find('.inline-editable').text();
								if( text != val && val != ''){
									$(this).hide();
								}else{
									$(this).show();
								}
							});
						}else{
							column.search( val ? '^'+val+'$' : '', true, false ).draw();
						}
					});

					var texts = [];
					column.data().unique().sort().each( function ( d, j ) {
						var inlineEditable = d.indexOf('<div class="inline-editable">');
						if(inlineEditable > -1){
							var text = d.substring('<div class="inline-editable">'.length, d.indexOf('</div>'));
							if(texts.indexOf(text) == -1){
								$select.find('select').append( '<option value="'+text+'">'+text+'</option>' )
								texts.push(text);
							}
						}else{
							$select.find('select').append( '<option value="'+d+'">'+d+'</option>' )
						}
					});

				}
            });
        }
	});
	
	/**
	* Define Custom order of DateRange Data in Table
	*/	 
	function dateRangeOrder(stringaDoubleDate) {		
		var dates=stringaDoubleDate.split(" - ");		
		var date1 = moment(dates[0],"DD/MM/YYYY");
		var date2 = moment(dates[1],"DD/MM/YYYY");		
	    return parseInt(date1+""+date2);
	}

	jQuery.extend( jQuery.fn.dataTableExt.oSort, {
		   "dateRangeOrder-pre": function ( stringaDoubleDate ) {
			   return dateRangeOrder(stringaDoubleDate);
		   },

		   "dateRangeOrder-asc": function ( x, y ) {
			   return dateRangeOrder(x) > dateRangeOrder(y);
		   },

		   "dateRangeOrder-desc": function ( x, y ) {
			   return dateRangeOrder(x) < dateRangeOrder(y);
		   }
	} );
	


	/******* TABLE ITEMS SELECTABLE *********/

	var partnersSelectableHandler = function(){
		// sorting_asc
		var $askForReportsButton = $('#ask-for-reports');
		var $selectAll = $('input[name="ask_report_all_toggle"]');
		var $form = $('#ask-reports');

		$askForReportsButton.click(function(ev){
			$form.submit();
		});

		$selectAll.click(function(ev){
			var $el = $(this);
			if($el.prop("checked")){
				$('input[name="ask_report"]').prop('checked', true);
			}else{
				$('input[name="ask_report"]').prop('checked', false);
			}
		});
	}

	var $partnersSelectable = $('table.partners-selectable');
	if($partnersSelectable.length > 0) partnersSelectableHandler();




	/******* INLINE EDIT ********************/

	$(document).on('click', 'button.open-inline-editor', function(){
		var $tr = $(this).closest('tr');
		$tr.find('.inline-editable').hide();
		$tr.find('.inline-editor').show();
		$(this).hide();
		$tr.find('.save-inline-editable').show();
	});

	$(document).on('click', 'button.save-inline-editable', function(){
		var $tr = $(this).closest('tr');

		var state = $tr.find('.inline-editor').find('select[name="state"]').val();
		var currency = $tr.find('.inline-editor').find('select[name="currency"]').val();
		var amount = $tr.find('.inline-editor').find('input[name="amount"]').val();

		if( state == '2' && !parseInt(amount) ){
			$tr.find('.inline-editor').find('input[name="amount"]').addClass('invalid');
			$tr.find('.inline-editor').find('input[name="amount"]').next('div').removeClass('valid-feedback').addClass('invalid-feedback').text('Invalid amount');
			return false;
		}

		var $form = $('#inline-form').html('');
		$form.append($tr.find('.inline-editor').find('input[name="id_order"]'));
		$form.append($tr.find('.inline-editor').find('input[name="amount"]'));
		$form.append('<input type="hidden" name="state" value="' + state + '">');
		$form.append('<input type="hidden" name="currency" value="' + currency + '">');
		$form.submit();

		$tr.find('.inline-editable').show();
		$tr.find('.inline-editor').hide();

		$(this).hide();
		$tr.find('.open-inline-editor').show();
	});


	/******* MODAL ********************/

	var $modal = $('.modal');
	if($modal.length>0){
		$modal.modal({
			keyboard: false,
			backdrop: 'static'
		});
		$modal.modal('show');
	}

	var $uploadBtnWrapper = $('.upload-btn-wrapper');
	if($uploadBtnWrapper.length>0){
		$uploadBtnWrapper.find('input[type="file"]').change(function(){
			var $form = $(this).closest('form');
			$form.submit();
		});
	}

}(jQuery));
